<script>
  import t from '#lib/i18n.svelte.js';
  import Icon from '#lib/Icon.svelte';
  import ButtonLabel from '#lib/ButtonLabel.svelte';

  let {
    icon,
    children,
    dismissible = false,
    class: css_classs,
    /** @type {'info' | 'warning' | 'error'} */
    variant = 'info'
  } = $props();

  let is_visibe = $state(true)
</script>

{#if children && is_visibe}
  <div 
    class='border-1 px py p-5 border-sm gap-x g-4 flex-row items-center {css_classs} {variant}'
  >
    {#if icon}
      <Icon name={icon} />
    {/if}
    {@render children()}
    {#if dismissible}
      <button onclick={()=>{is_visibe = false}} alt={t('close')}>
        <ButtonLabel start_icon='close' />
      </button>
    {/if}
  </div>
{/if}

<style lang='postcss'>
  div {
    &.info {
      background-color: var(--color-default-background-alpha-25);
      --color-stroke: var(--color-default-background-alpha-100);
    }
    &.warning {
      background-color: var(--color-emphasis-background);
      --color-foreground: var(--color-emphasis-foreground);
      --icon-color1: var(--color-emphasis-foreground);
    }
    &.error {
      background-color: oklch(from var(--color-destructive) l c h / 0.1);
      --color-stroke: var(--color-destructive);
      color: var(--color-destructive);
    }
  }
</style>